import React, { PureComponent, Component, useLayoutEffect, useEffect, useState, useRef } from 'react';
import ReactToolTip from 'react-tooltip';
import { CharacterComponent } from 'react/CharacterComponent';
import { Request } from 'components/Request';
import RankedRestrictionsComponent from 'react/matchmaking/RankedRestrictionsComponent';
import GeneralLargeBackButtonComponent from '../elements/GeneralLargeBackButtonComponent';
import EditMains from 'react/matchmaking/EditMains';
import RankedSlotSelections from 'react/matchmaking/RankedSlotSelections';

import PlayOptions from 'models/PlayOptions';
import { UserComponent } from 'react/UserComponent';
import ChoosePlayOptionsComponent from './ChoosePlayOptionsComponent';
import ActiveSelectableButton from '../elements/ActiveSelectableButton';
import { Character } from '../../models/Character';
import { LadderPopup } from '../../components/LadderPopup';
import MaterialInput from '../elements/MaterialInput';
import { ladderLocalStorage } from 'components/Ladder';
import LoaderFullPage from '../elements/LoaderFullPage';
import InputSwitch from '../elements/InputSwitch';
import TabButton from "../elements/TabButton";
import TabButtonHolder from "../elements/TabButtonHolder";
import RankedRestrictionTierDisplay from "./RankedRestrictionTierDisplay";
import TierRestriction from "../../models/TierRestriction";
import FancyCheckbox from "../elements/FancyCheckbox";

PickSearchesComponent.timesLoaded = 0;
PickSearchesComponent.fullPages = {
	EDIT_RANK_RESTRICTIONS: 'EDIT_RANK_RESTRICTIONS',
	EDIT_MAINS: 'EDIT_MAINS',
	INDEX: 'INDEX',
};
PickSearchesComponent.getMatchmakingFetchText = () => {
	const phrases = [
		'Getting Matchmaking Options Right Fast',
		'Fetching',
		'Retrieving',
	];
	if(PickSearchesComponent.timesLoaded > 1) {
		phrases.push('I Forgot The Options...');
	}
	if(PickSearchesComponent.timesLoaded > 5) {
		phrases.push('Fetching... Woof Woof');
	}
	if(PickSearchesComponent.timesLoaded > 10) {
		phrases.push('!!!');
	}

	PickSearchesComponent.timesLoaded++;
	return _.sample(phrases);
};

const setQueueOptionFromValue = (value) => {
	let setTo = null;
	if(value === null || value === '') {
		setTo = '';
	}
	else {
		setTo = Number.parseInt(value);
	}
	return setTo;
};


PickSearchesComponent.CUSTOM_QUEUE_ONLY = 0;
PickSearchesComponent.AUTO_QUEUE_ONLY = 1;
PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE = 2;
export default function PickSearchesComponent(props) {
	const { player, onExit, ladder } = props;
	const { matchSearchListManager, gameTypeIsPending, submittingSearches } = props;

	const [playOptions, updatePlayOptions] = useState(null);
	const [currentPage, updateCurrentPage] = useState(PickSearchesComponent.fullPages.INDEX);
	const [pageError, updatePageError] = useState(false);
	const [optionalTitle, updateOptionalTitle] = useState(myUser.previous_titles && myUser.previous_titles[ladder.id] ? myUser.previous_titles[ladder.id].title : '');

	const [checkedOptions, updateCheckedOptions] = useState({});
	const [bigSetMatchmakingActive, updateBigSetMatchmakingActive] = useState(false);

	const [queueSetting, updateQueueSetting] = useState(PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE);
	const [autoQueue, updateAutoQueue] = useState(false);
	const [customQueue, updateCustomQueue] = useState(false);
	const [changingQueueType, updateChangingQueueType] = useState(false);

	const [activeTab, updateActiveTab] = useState('types');
	const [pendingSlot, updatePendingSlot] = useState(null);
	const [exitingAfterMatchPick, updateExitingAfterMatchPick] = useState(false);
	const autoQueueOptionActive = true;

	// const { autoQueueServerIsActive, autoQueueServerStatusIsBeingChecked } = useSelector(state => state.matchmaking);
	// const dispatch = useDispatch();


	const loadingPhrase = useRef(PickSearchesComponent.getMatchmakingFetchText());


	const characters = player.ladder_information.getMainsForLadderAsMap(ladder.id);

	useLayoutEffect(() => {
		const ladderCheckedOptions = ladderLocalStorage.getItem('ladderCheckedOptions', {});
		if(_.isEmpty(ladderCheckedOptions)) {
			ladderLocalStorage.setItem('ladderCheckedOptions', {});
		}
		updateCheckedOptions(player.isMe() ? ladderCheckedOptions[ladder.id] || {} : {});

		let queueSetting = ladderLocalStorage.getItem('queueSettingSelected', PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE);

		if(!autoQueueOptionActive) {
		}

		if(!player.isMe()) {
			queueSetting = PickSearchesComponent.CUSTOM_QUEUE_ONLY;
		}

		updateQueueSetting(setQueueOptionFromValue(queueSetting));
	}, []);

	const hasAQueueTypeSelected = () => {
		return queueSetting !== '';
	};

	const startChangingQueueType = () => {
		updateChangingQueueType(true);
	};

	const queueOptionChange = (event) => {
		updateQueueSetting(setQueueOptionFromValue(event.target.value));
	};

	const bothQueueHintClicked = (event) => {
		updateQueueSetting(() => {
			return PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE;
		});
	};

	const autoQueueHintTextClicked = () => {
		updateQueueSetting(() => {
			return PickSearchesComponent.AUTO_QUEUE_ONLY;
		});
	};

	const customQueueHintTextClicked = () => {
		updateQueueSetting(() => {
			return PickSearchesComponent.CUSTOM_QUEUE_ONLY;
		});
	};

	useEffect(() => {
		switch(queueSetting) {
			case PickSearchesComponent.AUTO_QUEUE_ONLY:
				updateAutoQueue(true);
				updateCustomQueue(false);
				break;
			case PickSearchesComponent.CUSTOM_QUEUE_ONLY:
				updateAutoQueue(false);
				updateCustomQueue(true);
				break;
			case PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE:
				updateAutoQueue(true);
				updateCustomQueue(true);
				break;
			default:
				updateAutoQueue(false);
				updateCustomQueue(false);
				break;
		}
		ladderLocalStorage.setItem('queueSettingSelected', queueSetting);

	}, [queueSetting]);

	const gameTypeSelect = (event) => {
		const { value, checked } = event.target;
		const updatedCheckedOptions = { ...checkedOptions };

		const {
			friendlyOptionsSingles,
			friendlyOptionsDoubles,
			rankedOptionsSingles,
			rankedOptionsDoubles
		} = playOptions.createPlayOptions(player, bigSetMatchmakingActive);


		if(checked) {
			updatedCheckedOptions[value] = true;
		}
		else {
			delete updatedCheckedOptions[value];
		}

		const ladderCheckedOptions = ladderLocalStorage.getItem('ladderCheckedOptions');
		ladderCheckedOptions[ladder.id] = updatedCheckedOptions;
		ladderLocalStorage.setItem('ladderCheckedOptions', ladderCheckedOptions);

		updateCheckedOptions(updatedCheckedOptions);
	};
	/**
	 * stored options -> checked options -> checked options mapped
	 */

	useEffect(() => {
		retrievePlayOptions();
	}, []);

	const navigationClick = (newTab) => {
		updateActiveTab(newTab);
	};

	const renderSectionComplete = (tabName) => {
		const { success, error } = getSectionErrors(tabName);
		if(error) {
			return <div className='emphasized_negative'>{error}</div>;
		}
		return <div className='emphasized_bright'>{success}</div>;
	};

	const getSectionErrors = (tabName) => {
		const theReturn = {
			error: null,
			success: 'Complete',
		};
		switch(tabName) {
			case 'mains': {
				if(characters.size === 0) {
					theReturn.error = `No ${ladder.name} Mains Set`;
				}
				else {
					const useS = characters.size === 1 ? '' : 's';
					let beginningPart = '';
					if(characters.size === 1) {
						beginningPart = `${characters.values().next().value.name}`;
					}
					else {
						beginningPart = `${characters.size} ${ladder.name} Character${useS}`;
					}
					theReturn.success = `${beginningPart} Set As Your Main${useS}!`;
				}
				break;
			}
			case 'ranked_slot': {
				theReturn.success = (
					<div>Using Ranked Slot {pendingSlot || (!pendingSlot && playOptions.selected_slot)}</div>
				);
				break;
			}
			case 'types': {
				if(!hasAQueueTypeSelected()) {
					theReturn.error = 'Select A Queue Type!';
				}
				else if(!hasAGameModeSelected()) {
					theReturn.error = `Select A Game Mode!`;
				}
				else {
					const mappedCheckedOptions = getCheckedOptionsMapped();
					const amount = _.size(mappedCheckedOptions);
					const useS = amount === 1 ? '' : 's';
					if(amount === 1) {

					}
					else {

					}
					theReturn.success = `${amount} Queue${useS} Selected`;
				}
				break;
			}
			case 'rank_restrictions': {
				const theTier = TierRestriction.getLeagueFromRestriction(myUser.tier_restrictions[ladder.id], ladder);
				theReturn.success = (
					<RankedRestrictionTierDisplay
						restriction={myUser.tier_restrictions[ladder.id]}
						tier={theTier}
						ladder={ladder}
						showDivisionIfSelected={true}
						showIncludingUnrankedAlso={true}
					/>
				);
				break;
			}
		}
		return theReturn;
	};

	const toggleBigSetMatchmaking = () => {
		updateBigSetMatchmakingActive(previousValue => {
			return !previousValue;
		});
	};

	const getPlayOptionsMapped = () => {
		if(!playOptions) {
			return null;
		}

		const {
			friendlyOptionsSingles,
			friendlyOptionsDoubles,
			rankedOptionsSingles,
			rankedOptionsDoubles
		} = playOptions.createPlayOptions(player, bigSetMatchmakingActive);

		const all = {};

		const listed = [
			...friendlyOptionsSingles,
			...friendlyOptionsDoubles,
			...rankedOptionsSingles,
			...rankedOptionsDoubles
		];
		listed.forEach((playOption) => {
			all[playOption.toString()] = playOption;
		});
		return all;
	};

	const canConfirm = () => {
		return hasAGameModeSelected() && hasAQueueTypeSelected();
	};

	const hasAGameModeSelected = () => {
		return !_.isEmpty(getCheckedOptionsMapped());
	};

	const getCheckedOptionsMapped = (checkedOptionsDifferentFromState) => {
		return mapCheckedOptionsFromOptionList(checkedOptionsDifferentFromState ? checkedOptionsDifferentFromState : checkedOptions);
	};

	const mapCheckedOptionsFromOptionList = (checkedOptions) => {
		const allPlayOptions = getPlayOptionsMapped();
		if(!allPlayOptions) {
			return null;
		}
		const newList = {};
		_.each(checkedOptions, (checkedOption, value) => {
			// This makes sure that the option is a valid option based on what the user can currently see!
			if(allPlayOptions[value]) {
				newList[value] = allPlayOptions[value];
			}
		});

		return newList;
	};

	const gameTypeChooseAndSubmit = (option) => {
		gameTypeConfirm({ checkedOptions: { [option.toString()]: true } });
	};

	const gameTypeConfirm = ({ checkedOptions } = { checkedOptions: null }) => {

		let checkedOptionsMapped = null;
		if(checkedOptions) {
			checkedOptionsMapped = getCheckedOptionsMapped(checkedOptions);
		}
		else {
			checkedOptionsMapped = getCheckedOptionsMapped();
		}


		if(myUser.previous_titles && ladder) {
			myUser.previous_titles[ladder.id] = optionalTitle;
		}
		let autoQueueValue = null;
		if(autoQueue) {
			if(customQueue) {
				autoQueueValue = 2;
			}
			else {
				autoQueueValue = 1;
			}
		}
		else {
			autoQueueValue = 0;
		}

		props.gameTypeClick(checkedOptionsMapped, optionalTitle, autoQueueValue);
	};

	const gameTypeClick = (options) => {
		updateExitingAfterMatchPick(true);
	};

	const matchTitleChange = (event) => {
		updateOptionalTitle(event.target.value);
	};

	const changeRankedSlot = (slot) => {
		const data = {
			ladder_id: ladder.id,
			slot_number: slot.slot
		};
		updatePendingSlot(slot.slot);
		Request.apiv1('matchmaking/update_selected_rank_stats_slot', data)
			.then((response) => {
				showAvailableCharactersPopup(response);
				myUser.ladder_information.setSelectedSlotForLadder(ladder.id, response.probably_updated_to);
			})
			.then(() => {
				return retrievePlayOptions();
			})
			.catch((error) => {
				Request.generalJsonError(error);
			})
			.finally(() => {
				updatePendingSlot(null);
			});
	};

	const showAvailableCharactersPopup = (response) => {
		if(response.available_characters) {
			let availableCharacters = Character.updateMany(response.available_characters);
			let unavailableCharacters = Character.updateMany(response.unavailable_characters);

			const content = (
				<div className='slot'>
					<div className='available_characters'>
						<h4 className='page-sub-heading'>
							Available Characters for Slot {response.probably_updated_to}
						</h4>
						{availableCharacters.map((character) => (
							<CharacterComponent
								key={character.id}
								character={character}
							/>
						))}
					</div>
					<div className='unavailable_characters'>
						<h4 className='page-sub-heading'>Unavailable Characters (Used in Lower Numbered Slots)</h4>
						{unavailableCharacters.length > 0 && unavailableCharacters.map((character) => (
							<CharacterComponent
								key={character.id}
								character={character}
							/>
						))}
						{unavailableCharacters.length === 0 &&
						<h5>
							All Characters can be used for this slot!
						</h5>
						}
					</div>
				</div>
			);
			LadderPopup.create(content, 'Switched to rank slot ' + response.probably_updated_to, { buttons: true });
		}
	};

	const beginEditMains = () => {
		setCurrentEditMatchmakingPage(PickSearchesComponent.fullPages.EDIT_MAINS);
	};

	const endEditMains = () => {
		setCurrentEditMatchmakingPage(PickSearchesComponent.fullPages.INDEX);
	};

	const setCurrentEditMatchmakingPage = (page) => {
		updateCurrentPage(page);
	};

	const retrievePlayOptions = () => {
		return Request.apiv1Get('matchmaking/play_options', { ladder_id: ladder.id })
			.then((response) => {
				const { play_options } = response;
				if(play_options) {
					const season = {
						id: play_options.season_id,
						tiers: play_options.tiers
					};
					ladder.update({
						season: season
					});
					myUser.update({
						match_descriptions_are_allowed: play_options.match_descriptions_are_allowed,
						previous_titles: response.previous_titles,
					});
					updatePlayOptions(PlayOptions.create(response.play_options));
					updateOptionalTitle(myUser.previous_titles && myUser.previous_titles[ladder.id] ? myUser.previous_titles[ladder.id].title : '');
				}
			})
			.catch((response) => {
				Request.generalJsonError(response);
				console.error(response);
				updatePageError(true);
			});
	};

	if(pageError) {
		return (
			<React.Fragment>
				<GeneralLargeBackButtonComponent
					onClick={onExit}
				/>
				<div className='page_error'>
					<h5>There was an error loading the context!</h5>
				</div>
			</React.Fragment>
		);
	}

	if(currentPage === PickSearchesComponent.fullPages.EDIT_RANK_RESTRICTIONS) {
		return (
			<RankedRestrictionsComponent
				setCurrentEditMatchmakingPage={setCurrentEditMatchmakingPage}
				ladder={ladder}
				changingTierRestrictions
			/>
		);
	}

	if(currentPage === PickSearchesComponent.fullPages.EDIT_MAINS) {
		return (
			<React.Fragment>
				<GeneralLargeBackButtonComponent
					text='Done Editing Mains'
					onClick={endEditMains}
				/>
				<EditMains
					ladder={ladder}
					player={player}
				/>
			</React.Fragment>
		);
	}

	if(!playOptions) {
		return (
			<div>
				<GeneralLargeBackButtonComponent
					text='Back to Matchmaking'
					onClick={onExit}
				/>
				<LoaderFullPage
					text={loadingPhrase.current}
				/>
			</div>
		);
	}

	const {
		friendlyOptionsSingles,
		friendlyOptionsDoubles,
		rankedOptionsSingles,
		rankedOptionsDoubles
	} = playOptions.createPlayOptions(player, bigSetMatchmakingActive);

	const checkedOptionsMapped = getCheckedOptionsMapped();
	const gameTypeSectionProps = {
		onConfirm: gameTypeChooseAndSubmit,
		onSelect: gameTypeSelect,
		gameTypeIsPending: gameTypeIsPending,
		matchSearchListManager,
		exitingAfterMatchPick,
		checkedOptions: checkedOptionsMapped,
		player,
	};
	let hasSinglesSelected = false;
	let hasDoublesSelected = false;

	const all = [
		...friendlyOptionsSingles,
		...friendlyOptionsDoubles,
		...rankedOptionsSingles,
		...rankedOptionsDoubles
	];

	all.forEach((playOption) => {
		if(checkedOptionsMapped[playOption.toString()]) {
			if(playOption.teamSize === 1) {
				hasSinglesSelected = true;
				return false;
			}
			if(playOption.teamSize === 2) {
				hasDoublesSelected = true;
				return false;
			}
		}
	});

	const renderMainsContainer = () => (
		<div className='mains_display'>
			<div className='edit_mains_holder'>
				<div
					className={`edit_mains ${characters.size === 0 ? 'no_mains' : 'has_mains'}`}>
					{characters.size === 0 &&
					<div className='no_mains flex flex-row flex-space-between'>
						<div>
							<ActiveSelectableButton
								glow
								large
								onClick={beginEditMains}
							>
								Set Your Main Characters
							</ActiveSelectableButton>
						</div>
					</div>
					}
					{characters.size > 0 &&
					<div className='flex flex-row flex-space-between'>
						{false && <div>
							<ActiveSelectableButton
								large
								onClick={beginEditMains}
							>
								Update Your Main Characters
							</ActiveSelectableButton>
						</div>
						}
						<div
							className='mains_container clickable characters form-group'
							onClick={beginEditMains}
						>
							{Array.from(characters).map(([_, character]) => (
								<CharacterComponent key={character.id} character={character} />
							))}
						</div>
					</div>

					}
				</div>
			</div>
		</div>
	);

	const renderRankedSlotsContainer = () => (
		<RankedSlotSelections
			slots={playOptions.slots}
			selectedSlot={playOptions.selected_slot}
			pendingSlot={pendingSlot}
			ladder={ladder}
			changeRankedSlot={changeRankedSlot}
		/>
	);

	const renderLobbyTitleContainer = () => {
		if(!hasAQueueTypeSelected()) {
			return null;
		}
		return (
			<div className='lobby_title'>
				<div className='form-group'>
					<MaterialInput
						onChange={matchTitleChange}
						value={optionalTitle}
						type='text'
						name='title'
						placeholder=''
						maxLength='45'
						autoComplete='off'
						label='Lobby Name (Listed only)'
					/>
				</div>
			</div>
		);
	};

	const renderRankedRestrictionsContainer = () => (
		<RankedRestrictionsComponent
			setCurrentEditMatchmakingPage={setCurrentEditMatchmakingPage}
			ladder={ladder}
		/>
	);

	const renderAutoMatchmakingToggle = () => (
		<React.Fragment>
			<h4 className='page-sub-heading'>Matching</h4>
			<div className='queues_to_join flex flex-row flex-space-between'>
				<div className='option_descriptions'>
					<QueueTypeOption
						onClick={bothQueueHintClicked}
						selected={queueSetting === PickSearchesComponent.AUTO_QUEUE_AND_CUSTOM_QUEUE}
						title='Auto-match + listed (Recommended)'
						showDescription={changingQueueType}
						description={
							<React.Fragment>
								<div>
									Opponents will be found automatically, and others can see your search in the list and challenge you
								</div>
							</React.Fragment>
						}
					/>
					<QueueTypeOption
						onClick={autoQueueHintTextClicked}
						selected={queueSetting === PickSearchesComponent.AUTO_QUEUE_ONLY}
						showDescription={changingQueueType}
						title={<React.Fragment>
							<i className='fa fa-magic' />{' '}
							Auto-match only <span className='emphasized_negative'>{' '}(Beta v2.1)</span>

						</React.Fragment>}
						description={
							<React.Fragment>
								<div>
									Opponents will be found automatically
								</div>
								<div>
									Others <span className='emphasized_negative'>cannot</span>{' '}
									see that you are searching in the main list
								</div>
							</React.Fragment>
						}
					/>
					<QueueTypeOption
						onClick={customQueueHintTextClicked}
						selected={queueSetting === PickSearchesComponent.CUSTOM_QUEUE_ONLY}
						showDescription={changingQueueType}
						title={
							<React.Fragment>
								<i className='fa fa-suitcase' />{' '}
								Listed only
							</React.Fragment>
						}
						description={
							<React.Fragment>
								<div>
									Others within your preferences will be able to see that you're searching!
								</div>
							</React.Fragment>
						}
					/>
				</div>
			</div>
		</React.Fragment>
	);

	const renderChoosePlayOptionsContainer = () => {
		if(!hasAQueueTypeSelected()) {
			return null;
		}
		return (<div className='game_types'>
				<div className='form-group'>
					<ChoosePlayOptionsComponent
						playerCount={1}
						friendlies={friendlyOptionsSingles}
						ranked={rankedOptionsSingles}
						allDisabled={hasDoublesSelected}
						{...gameTypeSectionProps}
					/>
					<ChoosePlayOptionsComponent
						playerCount={2}
						friendlies={friendlyOptionsDoubles}
						ranked={rankedOptionsDoubles}
						allDisabled={hasSinglesSelected || hasDoublesSelected}
						{...gameTypeSectionProps}
					/>
				</div>
				<div className='form-group'>
					<InputSwitch
						onChange={toggleBigSetMatchmaking}
						value='1'
						checked={bigSetMatchmakingActive}
						content='Show BIG Game Count'
					/>
				</div>
				{!hasAGameModeSelected() &&
				<h5 className='emphasized_negative italics'>Choose At Least One Game Mode!</h5>
				}
			</div>
		);
	};

	return (
		<React.Fragment>
			<div id='matchmaking_popup' className='play_match_container'>
				<GeneralLargeBackButtonComponent
					text='Back to Matchmaking'
					onClick={onExit}
				/>
				{!player.isMe() &&
				<div className='opponent'>
					<h4>
						<UserComponent
							user={player}
						/>
					</h4>
					<img className='game_logo' src={ladder.smallImageUrl()} />
				</div>
				}
				<div className='final_option'>
					<ConfirmSearchButton
						player={player}
						onClick={gameTypeConfirm}
						canConfirm={canConfirm()}
						submittingSearches={submittingSearches}
					/>
				</div>
				<TabButtonHolder
					selectedTab={activeTab}
					stretch
					displayChildContent
					tabContentClassName='text-left the_options'
					childContentClassName='option_section'
				>
					{player.isMe() &&
					<TabButton
						name='mains'
						selectedTab={activeTab}
						onClick={navigationClick}
						tabTip={renderSectionComplete('mains')}
						content={
							renderMainsContainer()
						}
					>
						Mains
					</TabButton>
					}
					{!myUser.is_a_new_account && playOptions.can_have_multiple_ranked_slots &&
					<TabButton
						name='ranked_slot'
						selectedTab={activeTab}
						onClick={navigationClick}
						tabTip={renderSectionComplete('ranked_slot')}
						content={renderRankedSlotsContainer()
						}
					>
						Ranked Slot
					</TabButton>
					}
					{player.isMe() &&
					<TabButton
						name='rank_restrictions'
						selectedTab={activeTab}
						onClick={navigationClick}
						tabTip={renderSectionComplete('rank_restrictions')}
						content={renderRankedRestrictionsContainer()
						}
					>
						Rank Restrictions
					</TabButton>
					}
					<TabButton
						name='types'
						selectedTab={activeTab}
						onClick={navigationClick}
						tabTip={renderSectionComplete('types')}
						content={
							<div className='container-fluid'>
								{player.isMe() &&
								<div className='row form-group'>
									<div className='col-md-12'>
										{renderAutoMatchmakingToggle()}
									</div>
								</div>
								}
								{player.isMe() && player.match_descriptions_are_allowed && customQueue &&
								<div className='row'>
									<div className='col-md-6'>
										{renderLobbyTitleContainer()}
									</div>
								</div>
								}
								<div className='row'>
									<div className='col-md-12'>
										{renderChoosePlayOptionsContainer()}
									</div>
								</div>
							</div>
						}
					>
						Searches
					</TabButton>
				</TabButtonHolder>
			</div>
		</React.Fragment>
	);
}

function QueueTypeOption({ title, description, onClick, showDescription, selected }) {

	showDescription = true;
	return (
		<div
			onClick={onClick}
			className={`flex flex-row flex-no-wrap clickable hoverable ${selected ? 'selected' : 'deselected'}`}
		>
			{showDescription &&
			<FancyCheckbox
				checked={selected}
			/>
			}
			<div className='description'>
				<h4>
					{title}
				</h4>
				{showDescription &&
				<div>
					{description}
				</div>
				}
			</div>
		</div>
	);
}

class ConfirmSearchButton extends PureComponent {
	static instances = 1;

	constructor(props) {
		super(props);
		this.instanceNumber = ConfirmSearchButton.instances++;
	}

	render() {
		const { player, onClick, canConfirm, submittingSearches } = this.props;

		if(!player.isMe()) {
			return null;
		}
		const tipId = `tip_confirm_search_${this.instanceNumber}`;
		return (
			<React.Fragment>
				<ReactToolTip
					id={tipId}
					type='dark'
					effect='solid'
				>
					<span>You need to select at least one of the Friendlies or Ranked checkbox options</span>
				</ReactToolTip>
				<div
					data-tip
					data-for={tipId}
					data-tip-disable={canConfirm}
					className='form-group'>

					<ActiveSelectableButton

						onClick={onClick}
						disabled={!canConfirm || submittingSearches}
						glow={canConfirm}
						large
					>
						Confirm Search{' '}
						{submittingSearches && <i className='fa fa-cog fa-spin' />}
					</ActiveSelectableButton>
				</div>
			</React.Fragment>
		);
	}
}


